 type AlarmsColumn =
 'TICKET_ID' |
 'DATE_STATE' |
 'STATION_NAME' |
 'TAG' |
 'MESSAGE' |
 'ACTION' |
 'STATE';
const AlarmsColumns = (() => {
  const TICKET_ID: AlarmsColumn = 'TICKET_ID';
  const DATE_STATE: AlarmsColumn = 'DATE_STATE';
  const STATION_NAME: AlarmsColumn = 'STATION_NAME';
  const TAG: AlarmsColumn = 'TAG';
  const MESSAGE: AlarmsColumn = 'MESSAGE';
  const ACTION: AlarmsColumn = 'ACTION';
  const STATE: AlarmsColumn = 'STATE';
  function values(): AlarmsColumn[] {
    return [
     TICKET_ID,
     DATE_STATE,
     STATION_NAME,
     TAG,
     MESSAGE,
     ACTION,
     STATE
    ];
  }
  return { TICKET_ID, DATE_STATE, STATION_NAME, TAG, MESSAGE, ACTION, STATE, values };
})();

export { AlarmsColumns };
